import { Container, Form, Row } from "react-bootstrap";
import SubmitButton from "../../Components/Button";
import TextInput from "../../Components/TextInput";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authentication } from "../../api/common";
import { LoginResponse } from "../../commonTypes";
import { setUserInfo } from "../../reducers/userSlice";
import { AppDispatch } from "../../store";
import { encrypt, setSessionStorage } from "../../utils";
import styles from "./style.module.scss";
import quoteIcon from "../../icons/quote.svg";
import A360Logo from "../../icons/loginA360Logo.png";
import Alert from "../../Components/AlertPopup";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isValid, setIsvalid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [showServerDown, setShowServerDown] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("sessionExpired") === "true") {
      setShowSessionExpired(true);
      // Clear the query parameter from URL
      searchParams.delete("sessionExpired");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const handleServerDown = () => {
      setShowServerDown(true);
    };

    window.addEventListener("server-down-error", handleServerDown);

    return () => {
      window.removeEventListener("server-down-error", handleServerDown);
    };
  }, []);

  const handleLogin = async (
    e: React.FormEvent<HTMLFormElement> | React.MouseEvent,
  ) => {
    e.preventDefault(); // 🛑 prevent page reload
    switch (true) {
      case username.trim() === "":
        setIsvalid(false);
        return;
      case password.trim() === "":
        setIsvalid(false);
        return;
      default:
        setIsvalid(true);
        break;
    }
    setLoading(true);

    try {
      const response = (await authentication(
        encrypt(username),
        encrypt(password),
      )) as LoginResponse;
      const userInfo = {
        id: response.id,
        name: response.name,
        role: response.role,
        email: response.email,
        auditor: response.auditor,
        organizationId: response.organizationId,
        auditTypeId: response.auditTypeId,
      };

      dispatch(setUserInfo(userInfo));
      setSessionStorage(
        "user",
        encrypt(
          JSON.stringify({
            name: userInfo.name,
            role: userInfo.role,
            email: userInfo.email,
            auditor: userInfo.auditor,
          }),
        ),
      );

      // Store token expiry time for auto-logout
      const expiryTime = Date.now() + response.sessionDurationSeconds * 1000;
      sessionStorage.setItem("tokenExpiry", expiryTime.toString());

      navigate("/overview/audit-overview");
      setLoading(false);
    } catch (err : any) {
      setLoading(false);
      setShowToast(true);
      if (!navigator.onLine) {
        setErrorTitle("Connection Error");
        setError("Unable to connect. Verify your internet connection.");
        return;
      }

      setErrorTitle("Authentication Error");
      setError("Login failed. Please check your credentials.");
    }
  };

  const handleClose = () => setShowToast(false);
  return (
    <Container fluid className={styles.fullPage}>
      <Row className="g-0">
        <div>
          <div className={styles.logo}>
            <img src={A360Logo} alt="Logo" />
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div className={styles.formCard}>
            <Form>
              <h4 className={styles.loginheader}>Login</h4>
              {/* <p  className={styles.paragraphcolor}>
            Don’t have an account? <Link>Create now</Link>
          </p> */}

              <Form.Group controlId="formUsername" className="mb-3">
                <Form.Label className={styles.FieldLabel}>Username</Form.Label>
                <TextInput
                  name="username"
                  id="username"
                  onChange={(e) => setUsername(e.target.value)}
                  isInvalid={!isValid && !username}
                  errrorMessage={
                    !isValid && !username ? "Enter your username" : ""
                  }
                  placeholder="Enter your username"
                  className={styles.loginLabel}
                />
              </Form.Group>

              <Form.Group controlId="formPassword" className="mb-3">
                <Form.Label className={styles.FieldLabel}>Password</Form.Label>
                <TextInput
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  isInvalid={!isValid && !password}
                  errrorMessage={
                    !isValid && !password ? "Enter your password" : ""
                  }
                  placeholder="Enter your password"
                  className={styles.loginLabel}
                />
              </Form.Group>

              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <Form.Check type="checkbox" className={styles.FieldLabel} label="Remember me" /> */}
                {/* <Link>Forgot Password?</Link> */}
              </div>

              <SubmitButton
                width="100%"
                onClick={handleLogin}
                disabled={loading}
                className={styles.loginButton}
              >
                Login
              </SubmitButton>
            </Form>
            <Alert
              type="error"
              show={showToast}
              onClose={handleClose}
              title={errorTitle}
              message={error}
            />
            <Alert
              type="error"
              show={showSessionExpired}
              onClose={() => setShowSessionExpired(false)}
              title="Session Expired"
              message="Your session has expired. Please log in again."
            />
            <Alert
              type="error"
              show={showServerDown}
              onClose={() => setShowServerDown(false)}
              title="Server Unavailable"
              message="The server is currently unreachable. Please try again later."
            />
          </div>
          <div className={styles.quotecontent}>
            <img src={quoteIcon} alt="" />
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default Login;
